module.exports = __webpack_public_path__ + "static/media/stablishmentnewiconselected.3dabc29b.svg";